module.exports = __webpack_public_path__ + "static/media/ic_btm_sheet_high_returns.92a4a14e.svg";